import { render } from "./doneView.vue?vue&type=template&id=2b3a599c&scoped=true"
import script from "./doneView.vue?vue&type=script&lang=js"
export * from "./doneView.vue?vue&type=script&lang=js"

import "./doneView.vue?vue&type=style&index=0&id=2b3a599c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3a599c"]])

export default __exports__